module.exports = __webpack_public_path__ + "r-v3/img/exit_white.cb1b780b.svg";